import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpHeaders
} from '@angular/common/http';

import { Injectable } from '@angular/core';
import { AuthService } from '../services/services';
  
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const origen = req.headers.get('provider');
        if(origen !== 'AWS')
        {
            const authToken = this.authService.getToken();
            let headers = new HttpHeaders({
                'Authorization': 'Bearer ' + authToken,
                // 'ngrok-skip-browser-warning': 'Bearer ' ,


            });
    
            if (req.headers.has('codepin')) {
                const valorHeaderPIN = req.headers.get('codepin');
                headers = headers.set('codepin', valorHeaderPIN);
            }
            if(req.method == "POST"){
                headers.append('Content-Type', 'application/x-www-form-urlencoded');}
            const authRequest = req.clone({headers});
            return next.handle(authRequest);
        }
        return next.handle(req);
    }
}